import { copyTextToClipboard } from '@theme/theme-global';

if (!customElements.get('share-button-button')) {
  customElements.define(
    'share-button-button',
    class ShareButtonButton extends HTMLButtonElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
      }

      connectedCallback() {
        this.classList.remove('hidden');
        this.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }

      get urlToShare() {
        return this.dataset.copyText || document.location.href;
      }

      async handleClick(event) {
        event.preventDefault();

        if (navigator.share) {
          try {
            await navigator.share({ url: this.urlToShare, title: document.title });
          } catch (error) {
            if (error.name !== 'AbortError') {
              console.info(error);
            }
          }
          return;
        }

        const copied = await copyTextToClipboard(this.urlToShare);
        if (copied) {
          this.classList.add('copied');
          this.setAttribute('aria-label', window.accessibilityStrings.shareSuccess);
          setTimeout(() => {
            this.classList.remove('copied');
            this.removeAttribute('aria-label');
          }, 1500);
        } else {
          this.setAttribute('aria-label', window.accessibilityStrings.shareCopyToClipboard);
          setTimeout(() => {
            this.removeAttribute('aria-label');
          }, 2000);
        }
      }

      updateUrl(url) {
        this.dataset.copyText = url;
      }
    },
    { extends: 'button' },
  );
}
